// Entry point of the VaultSync SPA. Everything is plain TypeScript + DOM: the
// server has no template engine, it just serves this bundle and /api.
import './style.css';
import { api } from './api.js';
import { App } from './app.js';
import { renderAuth } from './auth.js';
import { h } from './dom.js';

const root = document.getElementById('app');
if (!root) throw new Error('#app container is missing from index.html');

async function boot(): Promise<void> {
  try {
    const me = await api.me();
    if (!me.authenticated) {
      renderAuth(root!, me, () => void boot());
      return;
    }
    const app = new App(me, root!, () => void boot());
    await app.start();
  } catch (error) {
    root!.replaceChildren(
      h('div', { class: 'auth-screen' }, [
        h('div', { class: 'auth-card' }, [
          h('h1', { text: 'VaultSync' }),
          h('p', { class: 'error-text', text: `Cannot reach the server: ${(error as Error).message}` }),
          h('button', {
            class: 'primary-button',
            text: 'Retry',
            type: 'button',
            on: { click: () => void boot() },
          }),
        ]),
      ]),
    );
  }
}

void boot();
